// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Select_wrapper__3SHvg","select":"Select_select__3w63P","label":"Select_label__2746L","error":"Select_error__1spB-"};